import { render, staticRenderFns } from "./EnterTransferCode.vue?vue&type=template&id=cc44b09c&scoped=true&lang=pug&"
import script from "./EnterTransferCode.vue?vue&type=script&lang=js&"
export * from "./EnterTransferCode.vue?vue&type=script&lang=js&"
import style0 from "./EnterTransferCode.vue?vue&type=style&index=0&id=cc44b09c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc44b09c",
  null
  
)

export default component.exports